export const SCHEDULES = "/api/v2/schedules";
export const BRANCHES = "/debdash/api/branch/listbycompany";
export const DATES = "/api/v1/web/appointment/availabledays";
export const APPOINTMENTS = "/api/v2/appointments";